export const whatsAppMessageUtil = (
  phoneNumber: string,
  message: string,
  isWebView: boolean,
  // isIphone: boolean,
) => {
  const webLink = `https://wa.me/${phoneNumber}?text=${message}`;
  // const appLink = `whatsapp://send?phone=${phoneNumber}&text=${message}`;

  if (isWebView) {
    window.NativeBridge.callDeeplink(
      `https://deeplink.plumhq.com/home?screen=weboutside&id=${webLink}`,
    );
    // if (isWebView) {
    //   window.location.href = appLink;
  } else {
    window.open(webLink, '_blank');
  }
};
